/** Query param the activities route uses for the opened booking. */
export const BOOKING_NUMBER_QUERY_PARAM = 'bookingNumber';

/** Query param of the legacy Tickets screen. */
export const TICKET_QUERY_PARAM = 'ticket';

export enum TicketsStep {
	list = 'list',
	details = 'details',
	qr = 'qr',
}

export const DEFAULT_DTICKET_NAME = 'Deutschlandticket';
